import React, { useMemo, useEffect } from 'react';
import classnames from 'classnames';
import { Layout } from 'tea-component';
import './index.scss';
import DataSelector from './components/DateSelector/index';
import LinkSelector from './components/LinkSelector/index';
import ImgLinker from './components/ImgLinker/index';
import useData, {
  useCurrentReportEffect,
  useImgsLoadingStateEffect,
  useDownloadReportEffect,
} from './_hooks';
import SimpleDownloadSelect from '@intelligence/components/SimpleDownloadSelect';
import InlineWatermark from '@intelligence/components/InlineWatermark';
import { captureExpendClassName } from '@intelligence/utils/captureUtils';
import GameSelect from './components/GameSelect';
import Loading from '@/pages/intelligence/components/Loading';
import MarqueeBanner from '@intelligence/components/MarqueeBanner/index';
import { useIntl, useSelector, history } from 'umi';
const { Content } = Layout;

export default function trendingGames(props: any) {
  const { formatMessage } = useIntl();
  const {
    selectedIdx,
    selectedUidAndId,
    isShow,
    headerList,
    timeList,
    selectedDate,
    imgList,
    ScrollRef,
    segRef,
    getTimeList,
    getSelectedDate,
    imgLoading,
    headerLoading,
  } = useData(props);

  const homeState = useSelector((state: any) => state?.home || {});
  const { isFromRecommendHome } = homeState;

  const { title, onGameSelect, onDateVersionSelect } = useCurrentReportEffect({
    games: headerList,
    dateVersions: (timeList as any)?.[selectedIdx],
  });

  const { imgsLoading, onImgLoad, onImgError } =
    useImgsLoadingStateEffect(imgList);

  const { node, downloading, onDownload } = useDownloadReportEffect({ title });

  const layoutRefreshDeps = useMemo<any[]>(() => [imgsLoading], [imgsLoading]);

  useEffect(() => {
    const handlePopState = () => {
      // 如果是从首页卡片推荐跳转至此页，则跳回原路径
      if (isFromRecommendHome && isFromRecommendHome !== '') {
        history.push(isFromRecommendHome);
      }
    };
    window.addEventListener('popstate', handlePopState);
    // 组件卸载时移除事件监听
    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, []);

  return (
    <Content>
      <div className={isShow ? 'dbi-trending-show' : 'dbi-trending-hide'}>
        <Content.Header
          title={formatMessage({ id: 'dbi_trendinggames_title' })}
          className="contentHead-normal dbi-trending-heading"
        >
          {headerLoading ? (
            <div style={{ height: 66, color: '#262832' }}>
              <Loading content={formatMessage({ id: 'common_loading' })} />
            </div>
          ) : (
            <GameSelect
              layoutRefreshDeps={layoutRefreshDeps}
              options={headerList}
              value={selectedIdx}
              selectedUidAndId={selectedUidAndId}
              onChange={(payload: any) => {
                getTimeList(
                  payload?.unified_id,
                  null,
                  payload?.type,
                  payload?.id,
                );
                onGameSelect(payload);
              }}
            />
          )}
        </Content.Header>
        <MarqueeBanner />
        {timeList[selectedIdx] && !imgLoading && (
          <div className="dbi-trending-body">
            <DataSelector
              timeList={timeList[selectedIdx]}
              getVer={selectedDate}
              getValue={getSelectedDate}
              ref={segRef}
              onSelect={onDateVersionSelect}
            />
            <LinkSelector gameIdx={selectedIdx} gameList={headerList} />
            <SimpleDownloadSelect
              className="dbi-trending-body__download-btn"
              loading={downloading}
              disabled={imgLoading || !imgList?.length || imgsLoading}
              onSelect={onDownload}
            />
          </div>
        )}
      </div>
      <Content.Body full ref={ScrollRef} className="dbi-trending-body">
        {imgLoading ? (
          <div style={{ height: 'calc(100vh - 290px)', color: '#262832' }}>
            <Loading content={formatMessage({ id: 'common_loading' })} />
          </div>
        ) : null}
        {/* <div
          className={imgLoading ? 'dbi-trending-loading' : 'dbi-trending-none'}
        >
          <Icon size="l" type="loading" />
          &nbsp;&nbsp;&nbsp;Loading…
        </div> */}
        {Array.isArray(imgList) && imgList?.length > 0 && !imgLoading ? (
          <div ref={node} className="dbi-trending-imgs">
            <ImgLinker
              imgList={imgList}
              gameIdx={selectedIdx}
              gameList={headerList}
              onImgLoad={onImgLoad}
              onImgError={onImgError}
            />
            <InlineWatermark
              className={classnames(
                'dbi-trending-imgs__watermark',
                captureExpendClassName,
              )}
            />
          </div>
        ) : (
          <div />
        )}
      </Content.Body>
    </Content>
  );
}
